<div
  class="tw-rounded-t-lg tw-border-b-2 tw-border-dashed tw-border-neutral-content tw-bg-neutral tw-p-2.5 tw-text-neutral-content"
>
  <div class="tw-mb-[0.3125rem] tw-text-center tw-text-[1.125rem] tw-uppercase">
    Tóm tắt hành trình
  </div>

  <div
    class="tw-mb-[0.3125rem] tw-flex tw-items-center tw-justify-between tw-leading-8"
  >
    <span class="tw-text-[1.375rem] tw-text-primary">
      {{ selectFlightState.from()?.code }}
    </span>
    <i class="fa-solid fa-plane"></i>
    <span class="tw-text-[1.375rem] tw-text-primary">
      {{ selectFlightState.to()?.code }}
    </span>
  </div>

  <div class="tw-mb-[0.3125rem] tw-flex tw-items-center tw-justify-between">
    <span>{{ selectFlightState.from()?.city }}</span>
    <span>{{ selectFlightState.to()?.city }}</span>
  </div>

  <div class="tw-mb-[0.3125rem] tw-flex tw-items-center tw-justify-between">
    <span>Ngày bay:</span>
    <span>{{ selectFlightState.date() | date: "EEEE, dd/MM/yyyy" }}</span>
  </div>

  @if (selectFlightState.roundTrip()) {
    <div class="tw-mb-[0.3125rem] tw-flex tw-items-center tw-justify-between">
      <span>Ngày về:</span>
      <span>
        {{ selectFlightState.returnDate() | date: "EEEE, dd/MM/yyyy" }}
      </span>
    </div>
  }

  <div class="tw-mb-[0.3125rem] tw-flex tw-items-center tw-justify-between">
    <span>Hành khách:</span>
    <span>
      @if (selectFlightState.adult() > 0) {
        <span>{{ selectFlightState.adult() }} người lớn</span>
      }
      @if (selectFlightState.child() > 0) {
        <span>, {{ selectFlightState.child() }} trẻ em</span>
      }
      @if (selectFlightState.infant() > 0) {
        <span>, {{ selectFlightState.infant() }} em bé</span>
      }
    </span>
  </div>

  <div class="tw-mb-[0.3125rem] tw-flex tw-items-center tw-justify-between">
    <span>Tổng tiền vé:</span>
    @if (totalPriceChange(); as totalPriceChange) {
      <div class="tw-flex tw-flex-col tw-items-end">
        <span class="tw-line-through">
          {{ totalPriceChange.current | number }}
        </span>
        <span>{{ totalPriceChange.new | number }}</span>
      </div>
    } @else {
      <span>{{ totalPrice() | number }}</span>
    }
  </div>

  @if (isRateCurrency()) {
    <app-currency-exchange-updated
      pageType="summary"
    ></app-currency-exchange-updated>
  }
</div>
